import { useEffect, useRef, useState } from "react"
import { MainContainer, NoDataCard } from "../../components"
import { usePost } from "../../api/reactQueryCustomHooks"
import { apiRoute, linksUrl } from "../../constants/enum"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPrint } from "@fortawesome/free-solid-svg-icons"
import { Button } from "@heroui/react"

const LotWiseDetail = () => {
    const { compCode } = useSelector((state) => state.company);
    const { detailLotNo } = useSelector((state) => state.stockEntry);
    const navigate = useNavigate();

    const { data = [], mutate: filterData } = usePost({
        url: apiRoute.stockEntry.fetchLotWiseDetail,
        queryKey: "lotwiseDetailtck",
    });

    useEffect(() => {
        if (detailLotNo.length > 0) {
            filterData({
                data: {
                    comp_code: compCode.join(","),
                    trade_of: "P",
                    l_code: detailLotNo.join(","),
                    pkt_type: ''
                },
            });
        }
    }, [detailLotNo]);

    const lots = data.reduce((acc, item) => {
        if (!acc[item.L_Code]) {
            acc[item.L_Code] = {
                rows: {},
                total: { pcs: 0, wt: 0 },
                stkTotal: { pcs: 0, wt: 0, rate: 0, rateD: 0, amt: 0, amtD: 0 },
            };
        }

        if (!acc[item.L_Code].rows[item.StkAt]) {
            acc[item.L_Code].rows[item.StkAt] = { pcs: 0, wt: 0, rate: 0, rateD: 0, amt: 0, amtD: 0 };
        }

        acc[item.L_Code].rows[item.StkAt].pcs += item.Nos;
        acc[item.L_Code].rows[item.StkAt].wt += item.Weight;
        acc[item.L_Code].rows[item.StkAt].rateD += item.AvgRateD;
        acc[item.L_Code].rows[item.StkAt].rate += item.AvgRate;
        acc[item.L_Code].rows[item.StkAt].amtD += item.TotalAmountD;
        acc[item.L_Code].rows[item.StkAt].amt += item.TotalAmount;
        acc[item.L_Code].total.pcs += item.Nos;
        acc[item.L_Code].total.wt += item.Weight;
        // acc[item.L_Code].total.amtD += item.TotalAmount;

        const exclude = ["Sale", "Inward", ""];
        if (!exclude.includes(item.StkAt)) {
            acc[item.L_Code].stkTotal.pcs += item.Nos;
            acc[item.L_Code].stkTotal.wt += item.Weight;
            acc[item.L_Code].stkTotal.rateD += item.AvgRateD;
            acc[item.L_Code].stkTotal.amtD += item.TotalAmountD;
        }

        return acc;
    }, {});
    console.log(lots)

    Object.keys(lots).forEach((lot) => {
        const lotRows = lots[lot].rows;
        const fixedOrder = ["Inward", "Sale", "Memo"];
        const otherRows = Object.keys(lotRows).filter((r) => !fixedOrder.includes(r));
        const orderedRows = {};

        fixedOrder.forEach((key) => {
            if (lotRows[key]) orderedRows[key] = lotRows[key];
        });
        otherRows.forEach((key) => (orderedRows[key] = lotRows[key]));

        lots[lot].rows = orderedRows;
    });

    const formatNum = (num) => (typeof num === "number" ? num.toFixed(2) : num);

    const getColor = (stkAt) => {
        if (["Inward", "Sale", ""].includes(stkAt)) return " text-slate-800 ";
        if (["Memo"].includes(stkAt)) return " text-green-500 ";
        return " text-red-500 ";
    };

    const [currentPrint, setCurrentPrint] = useState(null);
    const printRefs = useRef({});
    const cardRef = useRef();

    const handleClickPrev = () => {
        navigate(linksUrl.rptLotwisePosition);
    };
    const printCard = (lotNo) => {
        const card = document.getElementById(`${lotNo}`);
        if (!card) return;

        // Create hidden iframe
        const iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.right = "0";
        iframe.style.bottom = "0";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "none";
        document.body.appendChild(iframe);

        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

        const styles = Array.from(document.styleSheets)
            .map(sheet => {
                try {
                    return Array.from(sheet.cssRules)
                        .map(rule => rule.cssText)
                        .join("\n");
                } catch (e) {
                    return "";
                }
            })
            .join("\n");

        iframeDoc.open();
        iframeDoc.write(`
    <html>
      <head>
        <style>
          ${styles}

          /* Force paper size & small text */
          @page {
            size: 80mm 280mm;
            margin: 0mm;
          }

          @media print {
            body {
              margin: 0;
              -webkit-print-color-adjust: exact;
              font-size: 9px;
              line-height: 1.2;
            }

            .print-card {
              width: 80mm;
              padding: 4px;
            }

            .print-head, .print-row, .print-footer {
              font-size: 9px !important;
            }
                 .no-print {
                display: none !important;
                }
          }
        </style>
      </head>
      <body>
        ${card.outerHTML}
      </body>
    </html>
  `);
        iframeDoc.close();

        iframe.onload = () => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();

            // Clean up after printing
            setTimeout(() => {
                document.body.removeChild(iframe);
            }, 500);
        };
    };

    const printAllCards = () => {
        const cards = document.querySelectorAll(".print-card");
        if (!cards.length) return;

        const iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.right = "0";
        iframe.style.bottom = "0";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "none";
        document.body.appendChild(iframe);

        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

        const styles = Array.from(document.styleSheets)
            .map(sheet => {
                try {
                    return Array.from(sheet.cssRules)
                        .map(rule => rule.cssText)
                        .join("\n");
                } catch {
                    return "";
                }
            })
            .join("\n");

        iframeDoc.open();
        iframeDoc.write(`
    <html>
      <head>
        <style>
          ${styles}

          @page {
            size: A4;
            margin: 10mm;
          }

          @media print {
            body {
              margin: 0;
              -webkit-print-color-adjust: exact;
              font-size: 10px;
            }
              .print-card {
              width: 80mm;
              padding: 4px;
            }

            .print-head, .print-row, .print-footer {
              font-size: 9px !important;
            }
                
            .no-print {
              display: none !important;
            }

            .print-container {
              display: flex;
              flex-wrap: wrap;
              gap: 8mm;
            }

            .print-card {
              width: 90mm;
              border: 1px solid #e8e6e6ff;
              padding: 6px;
              page-break-inside: avoid;
            }
          }
        </style>
      </head>
      <body>
        <div class="print-container">
          ${Array.from(cards).map(card => card.outerHTML).join("")}
        </div>
      </body>
    </html>
  `);
        iframeDoc.close();

        iframe.onload = () => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            setTimeout(() => document.body.removeChild(iframe), 500);
        };
    };


    return (
        <MainContainer pageName="Lot Wise Info" breadcrumbs={["Reports", "Lot Wise Info"]}
            prevPage={{ show: true, onClick: handleClickPrev }}>
            {Object.keys(lots).length > 0 ? (
                <div className="mx-1 py-5">
                    <div className="w-full overflow-auto">
                        <div className="min-h-screen bg-slate-50">
                            <div className=" flex justify-between ">
                                <h2 className="text-orange-500 font-semibold text-sm">TOTAL LOTS: {Object.keys(lots).length}</h2>
                                <Button className="no-print" color="primary" size="sm" onPress={printAllCards}>
                                    Print All
                                </Button>
                            </div>
                            <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
                                {Object.entries(lots).map(([lotNo, lot]) => {
                                    const inwardAmtD = lot.rows["Inward"]?.amtD || 0;

                                    const inwardRateD = lot.rows["Inward"]?.rateD || 0;

                                    const saleAmtD = lot.rows["Sale"]?.amtD || 0;
                                    const saleWt = lot.rows["Sale"]?.wt || 0;

                                    // total (stock + sale + memo)
                                    const totalAmtD = (lot.stkTotal.amtD) + saleAmtD;
                                    const totalWt = (lot.stkTotal.wt || 0) + saleWt;
                                    const avgRateD = totalWt !== 0 ? totalAmtD / totalWt : 0;

                                    const avgStkRateD = lot.stkTotal.wt != 0 ? (lot.stkTotal.amtD || 0) / (lot.stkTotal.wt) : 0;
                                    const totalStkAmtD = (lot.stkTotal.wt || 0) * avgStkRateD;

                                    // difference
                                    const differenceAmt = totalAmtD - inwardAmtD;

                                    // final rate
                                    const differenceRate = avgRateD - inwardRateD;

                                    return (
                                        <div
                                            id={lotNo}
                                            key={lotNo}
                                            ref={cardRef}
                                            className="bg-white rounded-xl shadow border border-slate-200 p-5 relative print-card"
                                        >
                                            {/* Header */}
                                            <div className="flex justify-between mb-0 items-center">
                                                <h3 className="text-lg font-semibold text-indigo-700">Lot No: {lotNo}</h3>
                                                <button className="no-print" onClick={() => printCard(lotNo)}>
                                                    <FontAwesomeIcon className="text-xl text-orange-600" icon={faPrint}></FontAwesomeIcon>
                                                </button>
                                            </div>

                                            {/* Details */}
                                            <div className="divide-y divide-slate-200">
                                                <div className=" grid grid-cols-5 py-2 font-semibold text-slate-600 print-head ">
                                                    <div>Stock At</div>
                                                    <div className="text-right">Pcs</div>
                                                    <div className="text-right">Weight</div>
                                                    <div className="text-right">Rate($)</div>
                                                    <div className="text-right">Value($)</div>
                                                </div>
                                                {Object.entries(lot.rows).map(([stkAt, val]) => (
                                                    <div key={stkAt} className=" grid grid-cols-5 py-2 print-row ">
                                                        <div className={`${getColor(stkAt)}  text-xs whitespace-nowrap uppercase font-medium print-row`}  >{stkAt}</div>
                                                        <div className="text-right text-sm font-semibold print-row">{val.pcs}</div>
                                                        <div className="text-right text-xs font-semibold print-row">{formatNum(val.wt)}</div>
                                                        <div className="text-right text-xs font-semibold print-row">{formatNum(val.rateD)}</div>
                                                        <div className="text-right text-xs font-semibold print-row">{formatNum(val.amtD)}</div>
                                                    </div>
                                                ))}
                                            </div>
                                            {/* Footer Total */}
                                            <div className=" print-footer uppercase whitespace-nowrap text-xs  grid grid-cols-5 mt-0 py-2 border-t border-slate-200 font-bold text-indigo-700">
                                                <div className=" print-footer">Total Stock</div>
                                                <div className="text-right">{lot.stkTotal.pcs}</div>
                                                <div className="text-right">{formatNum(lot.stkTotal.wt)}</div>
                                                <div className="text-right">{formatNum(avgStkRateD)}</div>
                                                <div className="text-right">{formatNum(totalStkAmtD)}</div>
                                                <div></div>
                                            </div>
                                            <div
                                                style={{ fontSize: "0.8rem" }}
                                                className="uppercase grid grid-cols-[auto_1fr_auto] mt-0 pt-2 border-t border-slate-200 font-bold text-green-700 gap-2 items-center"
                                            >
                                                {/* Label (auto width) */}
                                                <div>Rate Diff ($)</div>

                                                {/* Expression (takes full available space) */}
                                                <div className="whitespace-nowrap text-center">
                                                    Avg ({formatNum(avgRateD)}) - Inw ({formatNum(inwardRateD)})
                                                </div>

                                                {/* Result (auto width) */}
                                                <div className="text-right font-bold whitespace-nowrap">
                                                    = {formatNum(differenceRate)}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}

                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <NoDataCard/>
            )}

            {/* Hidden printable card */}

        </MainContainer>
    );
};



export default LotWiseDetail